import React from 'react';
import PropTypes from 'prop-types';

import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

const hours = Array.from({ length: 24 }, (_, i) => i);
const minutes = Array.from({ length: 60 }, (_, i) => i);

function TimeSelectorDropdown({ rate, setHour, setMinute, setDays }) {
  return (
    <Form.Group as={Row}>
      <Form.Label column>Recurring Rate Expression</Form.Label>
      <Col md={2}>
        <Form.Label>Days (1-30)</Form.Label>
        <Form.Control
          type="number"
          min="1"
          max="30"
          value={rate.days}
          onChange={e => setDays(Math.min(30, Math.max(1, parseInt(e.target.value) || 1)))}
        />
      </Col>
      <Col md={2}>
        <Form.Label>Hour (0-23)</Form.Label>
        <Select
          value={{ label: rate.hour, value: rate.hour }}
          options={hours.map(h => ({ label: h, value: h }))}
          placeholder="Select hour"
          onChange={op => setHour(op?.value || 0)}
        />
      </Col>
      <Col md={3}>
        <Form.Label>Minute (0-59)</Form.Label>
        <Select
          value={{ label: rate.minute, value: rate.minute }}
          options={minutes.map(m => ({ label: m, value: m }))}
          placeholder="Select minute"
          onChange={op => setMinute(op?.value || 0)}
        />
      </Col>
      <Col md={12} className="mt-2">
        <small className="text-muted">
          Task will run every {rate.days === 1 ? 'day' : `${rate.days} days`} at {rate.hour || 0}:
          {(rate.minute || 0).toString().padStart(2, '0')}
        </small>
      </Col>
    </Form.Group>
  );
}

TimeSelectorDropdown.propTypes = {
  rate: PropTypes.shape({
    hour: PropTypes.number,
    minute: PropTypes.number,
    days: PropTypes.number,
  }).isRequired,
  setHour: PropTypes.func.isRequired,
  setMinute: PropTypes.func.isRequired,
  setDays: PropTypes.func.isRequired,
};

export default TimeSelectorDropdown;
